// RIMBARA MAJU SDN BHD — single editable catalogue collection.
// Edit names, prices, details, categories, conditions, images, display order
// and visibility (visible: true/false) for each listing below.

export const COMPANY = {
  name: "RIMBARA MAJU SDN BHD",
  ssm: "202601036825 (1698920-W)",
  address:
    "31, Lorong Zamrud 2/2, Taman Pekan Baru, 08000 Sungai Petani, Kedah Darul Aman, Malaysia",
  email: "rimbara2453@gmail.com",
  phoneDisplay: "011-33195516",
  phoneIntl: "+6011-33195516",
  whatsappNumber: "601133195516",
  location: "Sungai Petani, Kedah, Malaysia",
};

const ASSET_BASE =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_1e5d1ce6-6e6c-4539-944c-cf2150b6eb68/artifacts";
const ASSET_BASE_2 =
  "https://customer-assets-v7afamib.emergentagent.net/job_rimbara-fishing/artifacts";

export const ASSETS = {
  logo: `${ASSET_BASE}/a9d6a40516056426_Glossy%20Rimbara%20Maju%20Fish%20Emblem%20LOGO.png`,
  hero: `${ASSET_BASE}/47c442476acdbb35_rm006.jpg`,
  shop: [
    `${ASSET_BASE_2}/829e4be72e4b6c44_FISHING%20EQUIPMENT%20shop%20photo.webp`,
    `${ASSET_BASE_2}/aeb24654cdc308c5_ROD%20PHOTOS%201%20shop%20photo.webp`,
    `${ASSET_BASE_2}/0d56e58d685f48b0_Fishing%20Shop%20Photos.webp`,
  ],
};

// Shop gallery: owner confirmed these photographs show the company premises.
export const SHOW_SHOP_GALLERY = true;
export const SHOP_GALLERY_LABEL = "Our Shop";

export const PREOWNED_NOTE =
  "Please contact us for further photographs and details of wear, functionality and included items before ordering.";

export const CATALOGUE_NOTE =
  "Product availability, condition and final order details are confirmed through WhatsApp. Please enquire before making payment.";

export const CART_NOTE =
  "Subtotal excludes any applicable delivery charges. Availability, product condition and payment arrangements will be confirmed via WhatsApp.";

export const CATEGORIES = [
  "All Products",
  "Fishing Reels",
  "Electric Reels",
  "Fishing Rods",
];

export const CONDITIONS = [
  "All Conditions",
  "New",
  "Pre-owned",
  "Please enquire",
];

const RM001 = `${ASSET_BASE_2}/757d82d974930a22_rm001.webp`;
const RM002 = `${ASSET_BASE_2}/c81965fd61e018ff_rm002.jpg`;
const RM003 = `${ASSET_BASE_2}/13664d369d21d4f8_rm003.webp`;
const RM004 = `${ASSET_BASE_2}/fb5dd2030f593022_rm004.webp`;
const RM005 = `${ASSET_BASE}/546d5e629be78f5a_rm005.webp`;
const RM006 = `${ASSET_BASE}/47c442476acdbb35_rm006.jpg`;
const RM007 = `${ASSET_BASE_2}/149e16d24d4a4020_rm007%20USED%20FENWICK%20ROD%20RM199.jpg`;
const RM008 = `${ASSET_BASE_2}/8407af6497503f36_rm008%20BOMBADA%20PIRATA%20RM3199.webp`;
const RM009 = `${ASSET_BASE_2}/8f5732b8f5e071e0_rm009%20BOMBADA%20PASISTA%20RM1799.webp`;
const RM010 = `${ASSET_BASE_2}/993318264df8a2b6_rm010%20MAJOR%20CRAFT%20FINETAIL%20RM550.jpg`;
const RM011 = `${ASSET_BASE_2}/7a07d59e381f021d_rm011%20%5BUSED%5D%20SMITH%20TROUTIN%20RM1100.webp`;
const RM012 = `${ASSET_BASE_2}/6c2bf7d1549fa950_rm012%20DAIWAI%20FISHING%20REEL%20SEABORG%20500AT%20RM5899.webp`;
const RM013 = `${ASSET_BASE_2}/ebaad0d1a4894f13_rm013%20DAIWA%20SEABORG%20400JL%20RM3699.webp`;
const RM014 = `${ASSET_BASE_2}/7ca2cbcef557ace2_rm014%20DOUGLAS%20SKY%20G%20RM3999.webp`;

export const PRODUCTS = [
  {
    id: "rm-001",
    name: "Daiwa Saltiga 35N HL SJ Baitcasting Reel — Left Handle",
    category: "Fishing Reels",
    price: 2799.0,
    condition: "Please enquire",
    details: "Made in Korea; left-hand configuration.",
    extras: [],
    image: RM001,
    imageRef: "product-01",
    visible: true,
  },
  {
    id: "rm-002",
    name: "2022 Daiwa Saltiga 15 Overhead Jigging Baitcasting Reel",
    category: "Fishing Reels",
    price: 3299.0,
    condition: "Please enquire",
    details: "Made in Japan.",
    extras: [],
    image: RM002,
    imageRef: "product-02",
    visible: true,
  },
  {
    id: "rm-003",
    name: "Shimano 2019 Speedmaster Drum Reel",
    category: "Fishing Reels",
    price: 1599.0,
    condition: "Please enquire",
    details: null,
    extras: [],
    image: RM003,
    imageRef: "product-03",
    visible: true,
  },
  {
    id: "rm-004",
    name: "Daiwa 2025 Saltiga 300 Jigging Fishing Reel",
    category: "Fishing Reels",
    price: 2199.0,
    condition: "Please enquire",
    details: null,
    extras: [],
    image: RM004,
    imageRef: "product-04",
    visible: true,
  },
  {
    id: "rm-005",
    name: "Daiwa 2025 Saltiga 300L / 300HL — Left Handle",
    category: "Fishing Reels",
    price: 2699.0,
    condition: "Please enquire",
    details:
      "Left-hand configuration. Please confirm the required model, 300L or 300HL, through WhatsApp.",
    extras: [],
    image: RM005,
    imageRef: "product-05",
    visible: true,
  },
  {
    id: "rm-006",
    name: "Daiwa Saltiga 15HL-SJ Overhead Jigging Reel — Left Handle, T-Bar Handle",
    category: "Fishing Reels",
    price: 3299.0,
    condition: "Please enquire",
    details: "Made in Korea; left-hand configuration; T-bar handle.",
    extras: [],
    image: RM006,
    imageRef: "product-06",
    visible: true,
  },
  {
    id: "rm-007",
    name: 'Fenwick Atlanticstik Supreme ASB-5"MH',
    category: "Fishing Rods",
    price: 199.0,
    condition: "Pre-owned",
    details: null,
    extras: ["Seller condition rating: 8/10.", "Rod bag/sleeve not included."],
    image: RM007,
    imageRef: "product-07",
    visible: true,
  },
  {
    id: "rm-008",
    name: "BOMBADA PIRATA 711H",
    category: "Fishing Rods",
    price: 3199.0,
    condition: "Pre-owned",
    details: null,
    extras: [],
    image: RM008,
    imageRef: "product-08",
    visible: true,
  },
  {
    id: "rm-009",
    name: "Bombada Pasista 54",
    category: "Fishing Rods",
    price: 1799.0,
    condition: "Pre-owned",
    details: null,
    extras: [],
    image: RM009,
    imageRef: "product-09",
    visible: true,
  },
  {
    id: "rm-010",
    name: "Major Craft Finetail FSG-B38UL",
    category: "Fishing Rods",
    price: 550.0,
    condition: "Pre-owned",
    details: null,
    extras: [],
    image: RM010,
    imageRef: "product-10",
    visible: true,
  },
  {
    id: "rm-011",
    name: "SMITH Troutin Spin Multiyouse TRMK-C394UL",
    category: "Fishing Rods",
    price: 1100.0,
    condition: "Pre-owned",
    details: null,
    extras: [],
    image: RM011,
    imageRef: "product-11",
    visible: true,
  },
  {
    id: "rm-012",
    name: "Daiwa Seaborg 500AT Electric Fishing Reel",
    category: "Electric Reels",
    price: 5899.0,
    condition: "New",
    details: "Made in Japan.",
    extras: [],
    image: RM012,
    imageRef: "product-12",
    visible: true,
  },
  {
    id: "rm-013",
    name: "23 Daiwa Seaborg 400JL Electric Fishing Reel",
    category: "Electric Reels",
    price: 3699.0,
    condition: "Please enquire",
    details: null,
    extras: [],
    image: RM013,
    imageRef: "product-13",
    visible: true,
  },
  {
    id: "rm-014",
    name: "Douglas SKY-G Fly Rod",
    category: "Fishing Rods",
    price: 3999.0,
    condition: "Please enquire",
    details: null,
    extras: [],
    image: RM014,
    imageRef: "product-14",
    visible: true,
  },
];

export function formatRM(value, space = true) {
  const formatted = Number(value).toLocaleString("en-MY", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return space ? `RM ${formatted}` : `RM${formatted}`;
}

export function generalWhatsAppUrl() {
  const text =
    "Hello RIMBARA MAJU, I would like to enquire about your products.";
  return `https://wa.me/${COMPANY.whatsappNumber}?text=${encodeURIComponent(text)}`;
}

export function buildOrderWhatsAppUrl(lines, subtotal) {
  const parts = ["Hello RIMBARA MAJU, I would like to enquire about:", ""];
  lines.forEach((line) => {
    parts.push(
      line.name,
      `Condition: ${line.condition}`,
      `Quantity: ${line.qty}`,
      `Unit price: ${formatRM(line.price, false)}`,
      `Item total: ${formatRM(line.price * line.qty, false)}`,
      ""
    );
  });
  parts.push(
    `Merchandise subtotal: ${formatRM(subtotal, false)}`,
    "",
    "Please confirm availability, product condition, delivery charges and payment arrangements."
  );
  if (lines.some((l) => l.id === "rm-005")) {
    parts.push(
      "Please confirm the required model for the Daiwa 2025 Saltiga 300L / 300HL: 300L or 300HL."
    );
  }
  if (lines.some((l) => l.condition === "Pre-owned")) {
    parts.push(
      "For the pre-owned items, please confirm the condition and included items."
    );
  }
  return `https://wa.me/${COMPANY.whatsappNumber}?text=${encodeURIComponent(parts.join("\n"))}`;
}

export function scrollToSection(id) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
}
